import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import "../../styles/vendor/react-checkbox-tree.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { getUsers, getUsersForCurrentUser } from "../../services/api/users";
import {
  getCrewMembers,
  getMyCrewMembers
} from "../../services/api/crewMembers";
import CheckboxList from "./fields/CheckboxList";
import SimpleCheckbox from "./fields/SimpleCheckbox";
import { Trans } from "react-i18next";
import { FormikPropTypes } from "./helpers/formikPropTypes";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromCrewMembers: [],
      toUsers: []
    };

    this.fromCrewMemberIdTA = React.createRef();
    this.destinationUserIdsTA = React.createRef();

    this._handleSearchCrewMember = this._handleSearchCrewMember.bind(this);
    this._handleChangeCrewMember = this._handleChangeCrewMember.bind(this);
    this._handleSearchUser = this._handleSearchUser.bind(this);
    this._handleChangeUser = this._handleChangeUser.bind(this);
  }

  static propTypes = {
    ...FormikPropTypes,
    close: PropTypes.func,
    visible: PropTypes.bool,
    company: PropTypes.object,
    event: PropTypes.object,
    registration: PropTypes.object,
    periods: PropTypes.array,
    admin: PropTypes.bool
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (currentProps.visible && !nextProps.visible) {
      currentProps.resetForm();
    }
  }

  _handleSearchCrewMember(value) {
    if (this.props.admin) {
      getCrewMembers({
        "filter[registration_id]": this.props.registration.id,
        "filter[name_like]": value,
        include: "user"
      }).then(response => {
        this.setState({
          fromCrewMembers: response.data
        });
      });
    } else {
      getMyCrewMembers({
        "filter[registration_id]": this.props.registration.id,
        "filter[name_like]": value,
        include: "user"
      }).then(response => {
        this.setState({
          fromCrewMembers: response.data
        });
      });
    }
  }

  _handleChangeCrewMember(values) {
    if (values[0]) {
      this.props.setFieldValue("fromCrewMemberId", values[0].id);
    } else {
      this.props.setFieldValue("fromCrewMemberId", "");
    }
  }

  _handleSearchUser(value) {
    if (this.props.admin) {
      getUsers({
        "filter[company_id]": this.props.company.id,
        "filter[name]": value
      }).then(response => {
        this.setState({
          toUsers: response.data
        });
      });
    } else {
      getUsersForCurrentUser(this.props.company.id, {
        "filter[full_name]": value
      }).then(response => {
        this.setState({
          toUsers: response.data.map(user => user.user)
        });
      });
    }
  }

  _handleChangeUser(values) {
    if (values.length > 0) {
      this.props.setFieldValue(
        "destinationUserIds",
        values.map(user => user.id)
      );
    } else {
      this.props.setFieldValue("destinationUserIds", []);
    }
  }

  render() {
    const { handleSubmit, close, periods } = this.props;
    const { fromCrewMembers, toUsers } = this.state;

    return (
      <form className="m-form" onSubmit={handleSubmit}>
        <input type="hidden" name="id" />
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group m-form__group">
                <label>
                  <Trans>CopyCrewMemberFrom</Trans>
                </label>
                <AsyncTypeahead
                  multiple={false}
                  options={fromCrewMembers}
                  isLoading={false}
                  placeholder={"Search ..."}
                  minLength={2}
                  labelKey={item =>
                    item.user.firstName + " " + item.user.lastName
                  }
                  ref={this.fromCrewMemberIdTA}
                  onSearch={this._handleSearchCrewMember}
                  onChange={this._handleChangeCrewMember}
                />
              </div>

              <SimpleCheckbox
                {...this.props}
                name={"copyAccesses"}
                label={"Copy Days"}
              />

              {this.props.values.copyAccesses && (
                <CheckboxList
                  {...this.props}
                  label={"Periods"}
                  name={"periodIds"}
                  options={periods.map(period => {
                    return {
                      value: period.id,
                      title: period.name
                    };
                  })}
                />
              )}
            </div>
            <div className="col-lg-6">
              <div className="form-group m-form__group">
                <label>
                  <Trans>CopyCrewMemberTo</Trans>
                </label>
                <AsyncTypeahead
                  multiple={true}
                  options={toUsers}
                  isLoading={false}
                  placeholder={"Search ..."}
                  minLength={2}
                  labelKey={item => item.firstName + " " + item.lastName}
                  ref={this.destinationUserIdsTA}
                  onSearch={this._handleSearchUser}
                  onChange={this._handleChangeUser}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={close}>
            <Trans>Close</Trans>
          </button>
          <button type="submit" className="btn btn-primary">
            <Trans>Save</Trans>
          </button>
        </div>
      </form>
    );
  }
}

const CopyCrewMemberForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      fromCrewMemberId: "",
      destinationUserIds: [],
      periodIds: [],
      copyAccesses: false
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.destinationUserIds || values.destinationUserIds.length < 1) {
      errors.profileId = "required";
    }

    if (!values.fromCrewMemberId || values.fromCrewMemberId === "") {
      errors.occupationId = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default CopyCrewMemberForm;
